module.exports = __webpack_public_path__ + "img/img01.9e6119f6.png";